import { LazyLoadImage } from "react-lazy-load-image-component";
import photo from "../../assets/photos/UNM_HS-Wellness_Art-Walk-12_WEB.jpg";
import "./styles.scss";

function SectionTwelve({ placeholderSrc }) {
  return (
    <div>
      <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[45%_55%]">
        <div className="tw-relative">
          <LazyLoadImage
            alt="Water Feature"
            src={photo} // use normal <img> attributes as props
            placeholderSrc={placeholderSrc}
          />
          <div className="sectionNumber tw-absolute tw-font-extrabold xl:tw-text-[11.0rem] xl:tw-leading-[11.0rem] lg:tw-block">
            10
          </div>
        </div>
        <div className="tw-flex  lg:tw-mt-0 ">
          <div className="tw-px-4 tw-mt-auto lg:tw-mx-[3.0rem] xl:tw-w-3/4">
            <p className="tw-font-bold tw-italic tw-mb-4 tw-mb-0 tw-border-t-[1px] tw-border-white tw-pt-3 tw-text-2xl lg:tw-w-1/2 tw-mt-8 tw-text-2xl tw-w-1/2">
              Water Feature
            </p>
            <p>
              Rising like a New Mexico cinder cone in miniature, this seasonal
              water feature resides in front of the HSC Happy Heart Bistro,
              evoking a sense of growth and hope. The uneven, asymmetrical
              textures of the materials conjure the sense of history and
              geography so central to life in the Land of Enchantment.
            </p>
            <div className="tw-hidden sectionBorder tw-w-[100px;] lg:tw-mt-[1rem] lg:tw-mb-[3rem]"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SectionTwelve;
